import { render } from "./RuleManage.vue?vue&type=template&id=1ea984db&scoped=true&ts=true"
import script from "./RuleManage.vue?vue&type=script&lang=ts"
export * from "./RuleManage.vue?vue&type=script&lang=ts"

import "./RuleManage.vue?vue&type=style&index=0&id=1ea984db&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea984db"]])

export default __exports__